//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { EnterOutlined } from '@ant-design/icons';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';

//  -- Components ---------------------
import { Checkbox, Input as InputArea, Menu, Dropdown } from 'antd';

//  -- Constants ----------------------
import { Button, IconButton, Modal } from '@mui/material';
import {Snackbar } from '@mui/material';
import { Add, Close, Delete, KeyboardArrowDown, KeyboardArrowUp, MenuOutlined, ChevronLeft, ChevronRight } from '@mui/icons-material';
import ResizeAndDragabble from "components/ResizeAndDraggableWidget";

import {Alert} from '@mui/material';

import TextArea from 'antd/lib/input/TextArea';
import { DeleteModal } from "components/Dialog";
import { filter, find, get, has, map, sortBy, uniqBy } from "lodash";
import { useDispatch } from 'react-redux';
import { useCurrentClass } from 'store/classes/selectors';
import { useCurrentUser, useUserProfileConfig } from 'store/users/selectors';
import { useVocabulary } from 'store/vocabulary/selectors';
import { handleCreateVocabulary, handleGetStudentWordCount, handleDeleteVocabulary, handleListVocabularyNew, setDataVocabular , handleGenerateVocabularyWithAI , handleListVocabularyStud } from 'store/vocabulary/thunks';
import {
    buildTranslationPracticeListQuery,
    handleListTranslationPractice,
} from 'store/translationPractice/thunks';
import Loading from 'components/Loading';
import TextReader from 'components/Reader';
import { useAudio } from 'utils/context/AudioProvider';
import { setAudioChecker } from 'store/audio/actions';
import QnALoader from 'components/VocabQnAModal/QnALoader';
import { useExams } from 'store/exams/selectors';
import { useFocusOutside } from 'components/OnClickOutside';
import { handleListVocabularyCogantes, handleListVocabularyCogStud } from 'store/cogantes/thunks';
import { useCognets } from 'store/cogantes/selectors';
import CognateAiLoader from 'components/ebook/cogantes/cognateAiModal';
import { useOrientation } from 'components/hooks';
import { question_type_generate_more } from 'utils/config/reference';
import { useClassUsers } from 'store/userClasses/selectors';
import { getClassUsers } from 'store/userClasses/thunks';
import { useAllBook } from 'store/books/selectors';
import VocabPrint from 'modules/PrintVocabulary/VocabPrint';
import { useLocation } from "react-router-dom";
import { useMobileDetect } from 'hooks/useMobileDetect';
import { checkInappropriateContent } from 'utils/methods/word_filter';
import { handleAddInappropriateAlert } from 'store/logs/thunks';
import { useVoabPermissionForUser, useClassTogglePermission, useCurrentOrgPermission } from 'store/organizations/selectors';
import { useBookOrder } from 'store/books/selectors';
import * as Sentry from '@sentry/react';
import AllVocabulary from 'components/AllVocabulary';
import WordTranslationTable from './WordTranslationTable';
import SentryWrap from 'components/Sentry';
import { useAlert, useAlertActions } from 'components/UI/alertSakeBar/alertProvider';
import { handleStreamResponse } from 'utils/methods/QuestionCreateStreamHandle';
import AIUsageInfo from 'components/Modals/AiInfoModal';
import { useIsAdditionalBook } from 'utils/methods/functions';
import { formatValueDisplayForVocab } from 'utils/methods/math';

const ModalContent = styled.div`
   position: relative;
   border-radius: 10px;
   background-color: #fff;
   padding: 10px;
   height: 100%;
   width: 100%;
   overflow: visible;
   display: flex;
   flex-direction: column;
   z-index: 999999999;
 `;

const ActionText = styled.p`
    font-size:14px;
    color:white;
    font-weight:500;
`;
const StyledTable = styled.table`
  width: 100%; 
//   overflow-y: auto;
  max-height: 550px; 
  border-collapse: collapse; 
  td {
    border: 0.5px solid #fff; 
  }
  th {
    border: 0.5px solid #fff; 
  }
`;
const StyledHeader = styled.tr`
    position: sticky !important;
    top: 0;
    background-color: #fff; 
    z-index: 10;
`;
const StyledTh= styled.th`
    background: #5d4187;
    color: #ffffff;
`;

const CrossPrint = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 8px
`

const Vocabilary = ({ pageNumber, pageId, bookId, style, isCheckingOpen, setVocModal, vocabilaryButtonClassName="" , isVocabulary=false  , isOnlyForTeacher=false, from ="" , closeToolsDropdown = () => {}}) => {
    const showAlert = useAlert();
    const { ref, isFocused } = useFocusOutside();
    const currentUser = useCurrentUser()
    const currentClass = useCurrentClass()
    const bookVocabulary = useVocabulary();
    const bookCognets = useCognets();
    const classUsers = useClassUsers();
    const allBooks = useAllBook()
    const orgPermissions = useCurrentOrgPermission();
    const [alertSakeBar, setAlertSakeBar] = useState({ open: false, message: '', severity: "success" })
    const dispatch = useDispatch()
    const [openVocabulary, setVocabulary] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteVocab, setDeleteVocab] = useState({});
    const [addVocabData, setAddVocabData] = useState({});
    const [showWordLoader, setShowWordLoader] = useState(false)
    const [deleteVoc, setDeleteVoc] = useState(false);
    const [vocabularyAI, setVocabularyAI] = useState();
    const prevValueRef = useRef("");
    const prevValueRefStd = useRef("");
    const handleFocus = (value) => {
        prevValueRef.current = value;
    };
    const handleFocusStd = (value) => {
        prevValueRefStd.current = value;
    };
    const [getBooksVocab, setGetBooksVocab] = useState([]);
    const [newBooksVocab, setNewBooksVocab] = useState([]);
    const [studentCognates, setStudentCognates] = useState([]);
    const [vocLoader, setVocLoader] = useState(false);

    const [getBooksVocabStd, setGetBooksVocabStd] = useState([]);
    const [getOtherStudentsVocab, setGetOtherStudentsVocab] = useState([]);
    const [newItem, setNewItem] = useState({ isEditable: true });
    const [selectedAIVocab, setSelectedAIVocab] = useState([]);
    const [assignmentAiModal, setAssignmentAiModal] = useState(false);
    const [generateQnALoader, setGenerateQnALoader] = useState(false);
    const [questionGenerator, setQuestionGenerator] = useState([]);
    const [questionLoader, setQuestionLoader] = useState(false);
    const [qnaWord, setQnAWord] = useState('');
    const [aiModal, setAiModal] = useState(false);
    const [studentWordCounts, setStudentWordCounts] = useState([]);
    const vocabdomRef = useRef()
    const exams = useExams();
    const isExam = useMemo(() => exams?.flatMap((entry) => entry.exams.map((exam) => `${exam.bookId}`)).includes(`${bookId}`), [exams])
    const [tabSelector, setTabSelector] = useState({type: "page_vocab"});
    const isLandscape = useOrientation();
    const { stopAudio,setCurrentAudio } = useAudio();
    const [selectedWordCogantes,setSelectedWordCogantes] = useState([]);
    const tabSelectorTypeRef = useRef(tabSelector?.type);
    const [selectedTypes, setSelectedTypes] = useState(question_type_generate_more.map(option => option.value));
    const location = useLocation();
    const isMobile = useMobileDetect()
    const vocab_permission = useVoabPermissionForUser()
    const classTogglePermission = useClassTogglePermission()
    const bookOrder = useBookOrder()
    const isAdditionalBook = useIsAdditionalBook(bookId);
    const is_vocab_block_edit = useMemo(()=>currentUser.role=="student"&&vocab_permission&&vocab_permission.vocab,[vocab_permission,currentUser])
    const { isAiPermissionEnabled } = useUserProfileConfig();
    const [aiWithVoc, setAiWithVoc] = useState(false);
    const { showAlert: actionShowAlert } = useAlertActions();
    const questionRequestIdRef = useRef(0);
    const [showAccordin, setShowAccordin] = useState(true);
    const [dimensions, setDimensions] = useState({});
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        if (!assignmentAiModal) {
            questionRequestIdRef.current += 1;
            setQuestionGenerator([]);
            setGenerateQnALoader(false);
            setQuestionLoader(false);
            SetGenerateCount(0);
        }
    }, [assignmentAiModal]);
    
    // Check if vocabulary is allowed for the current book group
    const isVocabularyAllowedForBookGroup = useMemo(() => {
        if (currentUser.role !== "student") return true; // Teachers always have access
        // Find the book group for the current book
        const currentBookGroup = bookOrder?.find(order => 
            order.order && order.order.includes(bookId)
        );
        
        if (!classTogglePermission.vocabulary) return true; // Default to allowed if no restrictions
        if (!has(classTogglePermission.vocabulary, currentBookGroup?.key || isAdditionalBook?.key)) return true;

        if (isAdditionalBook?.key) {
            if (orgPermissions[isAdditionalBook?.key]) {
                return classTogglePermission.vocabulary[isAdditionalBook?.key];
            }
        }
        // Check if vocabulary is allowed for this book group
        return classTogglePermission.vocabulary[currentBookGroup?.key];
    }, [currentUser.role, bookId, bookOrder, classTogglePermission.vocabulary, isAdditionalBook])
    
    const [generatedCount,SetGenerateCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageStd, setCurrentPageStd] = useState(1);
    const [currentPageOtherStudents, setCurrentPageOtherStudents] = useState(1);
    const itemsPerPage = 20;
    const current_book = useMemo(() => {
        return find(allBooks ?? [], ['id', bookId])?.subTopics || [];
    }, [allBooks, bookId]);

    useEffect(() => {
        tabSelectorTypeRef.current = tabSelector?.type;
    }, [tabSelector?.type]);

    useEffect(() => {
        if (pageId === undefined || pageId === null) return;
        if (bookId === undefined || bookId === null) return;
        const payload = buildTranslationPracticeListQuery({
            bookId,
            pageId,
            classId: currentClass?.id,
            userRole: currentUser?.role,
            userId: currentUser?.id,
            teacherId: currentUser?.role === 'student' ? get(currentClass, "teacherId", '') : undefined,
        });
        const run = async () => {
            try {
                await dispatch(handleListTranslationPractice(payload));
            } catch (error) {
                Sentry.captureException(error);
            }
        };
        run();
    }, [dispatch, bookId, pageId, currentClass?.id, currentUser?.id, currentUser?.role]);

    const classStudents = filter(classUsers, (user) => user.role === 'student');
    
    const selectedAIVocabIds = useMemo(() => {
        return new Set(selectedAIVocab.map(item => item.id));
    }, [selectedAIVocab]);

    useEffect(() => {
        const updateWindowSize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
        
        updateWindowSize();
        window.addEventListener("resize", updateWindowSize);
        return () => {
            window.removeEventListener("resize", updateWindowSize);
        };
    }, []);

    const handleTouch = (event) => {
        event.preventDefault();
        handleVocabularyClose();
    };

    const handleAudioChecker = async () => {
        stopAudio();
        setCurrentAudio(null);
        await dispatch(setAudioChecker({isPlaying: false}));
    }
    
    useEffect(() => {
        if (isCheckingOpen) {
            setVocabulary(true);
            setSelectedAIVocab(getBooksVocab || []);
            if (currentUser?.role === 'teacher') {
             const isPageSpecific =
                tabSelector?.type === 'page_vocab' ||
                tabSelector?.type === 'my_vocab_stud';
              fetchStudentWordCounts(isPageSpecific);
            }
        }
        else {
            setVocabulary(false);
        }
    }, [isCheckingOpen])
    const filteredVocabulary = useMemo(() => {
        if (tabSelector?.type === "my_vocab_stud") return [];
        const filterVocab = filter(bookVocabulary, obj => obj.page == pageId);
        const filterByAdmin = filterVocab?.filter(data => data?.created_by === "owe_admin") || [];
        const filterByTeacher = filterVocab?.filter(data => data?.created_by === "teacher") || [];
        const data = [];
        if (filterByAdmin?.length > 0) data.push(...filterByAdmin);
        if (filterByTeacher?.length > 0) data.push(...filterByTeacher);
        const cloneIds = new Set(data.map(item => item.clone_id).filter(Boolean));
        const filtered = uniqBy(data.filter(item => !cloneIds.has(item.id)), 'id');
        return filtered || [];
    }, [bookVocabulary, bookId, pageId, tabSelector?.type]);

    const filteredStudentVocabulary = useMemo(() => {
        if (currentUser.role !== 'student') return [];
        const filterVocab = filter(bookVocabulary, obj =>  obj.page == pageId && obj.created_by == 'student');
        return filterVocab;
    }, [bookVocabulary, pageId, currentUser.role]);

    const filteredOtherStudentsVocabulary = useMemo(() => {
        if (currentUser.role !== 'student') return [];
        const filterVocab = filter(bookVocabulary, obj =>  obj.page == pageId && obj.created_by == 'student' && obj.user_id !== currentUser?.id
        );
        const sortedVocab = sortBy(
            filterVocab,
            o => (o.data && typeof o.data.word === 'string') ? o.data.word.toLowerCase().trim() : ''
        );
        return sortedVocab;
    }, [bookVocabulary, pageId, currentUser.role, currentUser?.id]);

    useEffect(() => {
        if (tabSelector?.type === "my_vocab_stud") return;
        if (tabSelector?.type === "unit_vocabulary") return;
        if (tabSelector?.type === "translation") return;
        if (currentUser.role == 'student') {
            setGetBooksVocabStd(filteredStudentVocabulary);
            if (tabSelector?.type !== "other_students_vocab") {
                setGetOtherStudentsVocab(filteredOtherStudentsVocabulary);
            }
            setGetBooksVocab(filteredVocabulary);
        } else {
            setNewBooksVocab(filteredVocabulary);
            setGetBooksVocab(filteredVocabulary);
        }
    }, [filteredVocabulary, filteredStudentVocabulary, filteredOtherStudentsVocabulary, tabSelector?.type, currentUser.role])

    useEffect(() => {
        if (openVocabulary && 
            (tabSelector?.type === "page_vocab" || tabSelector?.type === "unit_vocabulary" || tabSelector?.type === "my_vocab_stud") &&
            currentUser?.role === 'teacher' &&
            getBooksVocab?.length > 0) {
            setSelectedAIVocab(getBooksVocab || []);
        }
    }, [getBooksVocab, openVocabulary, pageId, tabSelector?.type, currentUser?.role])

    useEffect(() => {
        const fetchOtherStudentsVocab = async () => {
            if (tabSelector?.type === "other_students_vocab" && currentUser?.role === 'student' && openVocabulary && get(currentClass, "id")) {
                setVocLoader(true);
                try {
                    const classId = get(currentClass, "id");
                    
                    const allClassUsers = await getClassUsers(classId);
                    const allStudents = filter(allClassUsers, (user) => user.role === 'student' && user.active !== false);
                    const otherStudentIds = allStudents
                        .filter(student => student.id !== currentUser?.id)
                        .map(student => student.id);
                    
                    if (otherStudentIds.length === 0) {
                        setGetOtherStudentsVocab([]);
                        setVocLoader(false);
                        return;
                    }
                    
                    const vocabPromises = otherStudentIds.map(async (studentId) => {
                        const data = {
                            teacher_id: get(currentClass, "teacherId", ''),
                            user_id: studentId,
                            created_by: 'teacher_student',
                            page: pageId,
                            book_id: bookId
                        };
                        const result = await dispatch(handleListVocabularyStud(data, bookId, pageId, currentUser?.id));
                        return Array.isArray(result) ? result : [];
                    });
                    
                    const vocabResults = await Promise.allSettled(vocabPromises);
                    
                    const allVocabularies = vocabResults
                        .filter(result => result.status === 'fulfilled')
                        .flatMap(result => result.value)
                        .filter(vocab => vocab && vocab?.page == pageId && vocab?.created_by === 'student' && vocab?.user_id !== currentUser?.id);
                    
                    
                    const uniqueVocabularies = uniqBy(allVocabularies, (vocab) => {
                        const word = get(vocab, 'data.word', '').toLowerCase().trim();
                        return word;
                    });
                    const sortedUniqueVocabularies = sortBy(
                        uniqueVocabularies,
                        vocab => get(vocab, 'data.word', '').toLowerCase().trim()
                    );
                    
                    setGetOtherStudentsVocab(sortedUniqueVocabularies);
                } catch (error) {
                    console.error('Error fetching other students vocabularies:', error);
                    setGetOtherStudentsVocab([]);
                } finally {
                    setVocLoader(false);
                }
            } else {
                if (tabSelector?.type !== "other_students_vocab") {
                    setGetOtherStudentsVocab([]);
                }
            }
        };
        
        fetchOtherStudentsVocab();
    }, [tabSelector?.type, openVocabulary, currentUser?.role, currentUser?.id, pageId, bookId, currentClass, dispatch])

    const onFilterVocabularyStd = () => {
        let sorted_obj = sortBy(bookVocabulary,
            [
                function (o) {
                    if (o.data && typeof o.data.word === 'string') {
                        return o.data.word.toLowerCase();
                    }
                    return '';
                }
            ]);
        return sorted_obj;

    }


    useEffect(() => {
        setTimeout(() => {
            if (addVocabData.word == undefined) {
            } else {
                addVocabulary()
            }
        }, 2000)

    }, [vocabularyAI])



    useEffect(() => {
        const data = {
            teacher_id: currentUser.role == 'student'?get(currentClass, "teacherId", ''): get(currentUser, "id", ''),
            user_id: get(currentUser, "id", ''),
            created_by:currentUser.role == 'student'?'student':'teacher',
            class_id: currentUser.role == 'student'?get(currentClass, "id"):null,
            page: pageId,
            book_id: bookId
        }
        Promise.allSettled([
            dispatch(handleListVocabularyNew(data, bookId, pageId, currentUser?.id)),
            dispatch(handleListVocabularyCogantes(data, bookId, pageId, currentUser?.id))
        ])
    }, [])

    const closeAlert = () => {
        setAlertSakeBar({ open: false, message: '', severity: 'success' })
    }
    const handleVocabularyClose = () => {
        handleAudioChecker()
        toogleChange("page_vocab")
        if(setVocModal){
            setVocModal(false);
        }
        setVocabulary(false);
        setAddVocabData({})
        setVocabularyAI({})
        const dataToSend = getBooksVocab.filter(item => !item.isEditable);
        setGetBooksVocab(dataToSend)
        dispatch(setDataVocabular(onFilterVocabularyStd()));
    }

    const toogleChange = (value) => {
        setTabSelector({type:  value})
        setCurrentPage(1);
        setCurrentPageStd(1);
        setCurrentPageOtherStudents(1);
    }

    const handleCreateVocabularyQnA = async (_,count = 0,maxAttempts = 1,key='') => {
      try {
        const requestId = questionRequestIdRef.current + 1;
        questionRequestIdRef.current = requestId;
        if (!isAiPermissionEnabled) {
          showAlert(currentUser.role === 'student' ? 'Please ask teacher to enable AI permission to create a lesson.' : 'Please enable AI permission to create a lesson.', 'error');
          return;
        }
        const words = selectedAIVocab.map((item) => item.data?.word);
        const data = words.join(", ");
        if (selectedAIVocab?.length === 0 || data === "")
          return showAlert("Select atleast one vocabulary", "info");
        if (count === 0) {
            setAssignmentAiModal(true);
            setGenerateQnALoader(true);
            handleVocabularyClose();
          }
          await handleStreamResponse({
              path: "ai/generate/generate-questions-for-vocab",
              body: JSON.stringify({
                  topic:data,
                  answer_language: 'spanish',
                  generate_question_language: key
              }),
              onTitle: (title) => {
                  if (questionRequestIdRef.current !== requestId) return;
                  setQnAWord(title)
                  SetGenerateCount(0)
              },
              onQuestion: (question) => {
                  if (questionRequestIdRef.current !== requestId) return;
                  setQuestionGenerator(prev => [...prev, { ...question, id: Math.random() * 1000000000 }]);
                  SetGenerateCount(prev => prev + 1)
                  setQuestionLoader(false);
                  setGenerateQnALoader(false);
              },
              onDone: () => {
                  if (questionRequestIdRef.current !== requestId) return;
                  setGenerateQnALoader(false);
                  setQuestionLoader(false);
                  SetGenerateCount(0)
              },
              onError: () => {
                  if (questionRequestIdRef.current !== requestId) return;
                  setGenerateQnALoader(false);
                  setQuestionLoader(false);
                  SetGenerateCount(0)
              }
          })
        // const generatedQuestionData = await dispatch(
        //   handleCreateVocabularyAIQnA({
        //     topic: data,
        //   })
        // );
        // if (generatedQuestionData?.data?.length >= 0) {
        //   setGenerateQnALoader(false);
        //   setQuestionGenerator(generatedQuestionData?.data);
        //   setQnAWord(data);
        // } else {
        //     if(count < maxAttempts){
        //         await handleCreateVocabularyQnA(_,count + 1, maxAttempts);
        //         return;
        //     }
        //     showAlert("Please try again later!", "info");
        //     setAssignmentAiModal(false);
        //     setGenerateQnALoader(false);
        // }
      } catch (error) {
        Sentry.captureException(`256 Error in handleCreateVocabularyQnA: ${error}`);
        console.log(error);
      }
    };



    const handleGenerateMoreQnA = async (topic,language) => {
        const requestId = questionRequestIdRef.current + 1;
        questionRequestIdRef.current = requestId;
        if (!isAiPermissionEnabled) {
          showAlert(currentUser.role === 'student' ? 'Please ask teacher to enable AI permission to generate questions.' : 'Please enable AI permission to generate questions.', 'error');
          return;
        }
        const words = selectedAIVocab.map((item) => item.data?.word);
        const data = words.join(", ");
        setQuestionLoader(true);
        await handleStreamResponse({
           path: "ai/generate/generate-questions-for-vocab",
           body: JSON.stringify({
               topic: data,
               question_type: selectedTypes,
               answer_language: 'spanish',
               generate_question_language: language
           }),
           onTitle: (title) => {
               if (questionRequestIdRef.current !== requestId) return;
               setQnAWord(title)
               SetGenerateCount(0)
           },
           onQuestion: (question) => {
               if (questionRequestIdRef.current !== requestId) return;
               setQuestionGenerator(prev => [...prev, { ...question, id: Math.random() * 1000000000 }]);
               SetGenerateCount(prev => prev + 1)
               setQuestionLoader(false);
               setGenerateQnALoader(false);
           },
           onDone: () => {
               if (questionRequestIdRef.current !== requestId) return;
               setGenerateQnALoader(false);
               setQuestionLoader(false);
               SetGenerateCount(0)
           },
           onError: () => {
               if (questionRequestIdRef.current !== requestId) return;
               setGenerateQnALoader(false);
               setQuestionLoader(false);
               SetGenerateCount(0)
           }
        });
    }


    const handleCheckboxChange = (checked, value) => {
        if (checked) {
            setSelectedAIVocab((prev) => [...prev, value]);
        } else {
            setSelectedAIVocab((prev) => prev.filter((item) => item.id !== value.id));
        }
    }

    const handleUpdateData = async (data, propertyName) => {
        let datas = getBooksVocab.find(item => item.id === data?.id);
        if (!datas) {
            return;
        }
        if(datas?.created_by === 'owe_admin' && currentUser?.role === 'teacher'){
            datas.user_id = currentUser?.id;
            datas.created_by = 'teacher';
            datas.isAdminOne = true;
        }
        if (prevValueRef.current === datas.data[propertyName]) {
            return;
        }
        await dispatch(handleCreateVocabulary(datas,currentUser?.role));
        setAlertSakeBar({
            open: true,
            message: "Updated Successfully",
            severity: "success",
        })
    }

    const handleUpdateDataStd = async (data, propertyName) => {
        const datas = getBooksVocabStd.find(item => item.id === data?.id);
        if (!datas || !datas.data) {
            return;
        }
        if (prevValueRefStd.current === datas.data[propertyName]) {
            return;
        }
        await dispatch(handleCreateVocabulary(datas));
        setAlertSakeBar({
            open: true,
            message: "Updated Successfully",
            severity: "success",
        })
    }

    const onDeleteVocab = async () => {
        const isMyVocabTab = tabSelector?.type === "my_vocab";
        const currentDataArray = isMyVocabTab ? getBooksVocabStd : getBooksVocab;
        const currentDataLength = currentDataArray.length;
        const newDataLength = currentDataLength - 1;
        const maxPageAfterDelete = Math.ceil(newDataLength / itemsPerPage) || 1;
        
        await dispatch(handleDeleteVocabulary(deleteVocab?.id));
        
        if (isMyVocabTab) {
            if (currentPageStd > maxPageAfterDelete) {
                setCurrentPageStd(maxPageAfterDelete);
            }
        } else {
            if (currentPage > maxPageAfterDelete) {
                setCurrentPage(maxPageAfterDelete);
            }
        }
        
        setDeleteModal(false);
        setDeleteVoc(false);
        if (currentUser?.role === 'teacher') {
          const isPageSpecific =
            tabSelector?.type === 'page_vocab' || tabSelector?.type === 'my_vocab_stud';
          fetchStudentWordCounts(isPageSpecific);
        }
    }
    function editDataProperty(targetId, newValue, propertyName) {
        const itemToEdit = getBooksVocab.find(item => item.id === targetId);
        const updatedData = getBooksVocab.map((item) =>
            item.id === targetId
                ? {
                    ...item,
                    data: {
                        ...item.data,
                        [propertyName]: newValue,
                    },
                }
                : item
        );
        if (itemToEdit) {
            if(typeof itemToEdit.data === 'undefined'){
                itemToEdit.data = {};
            }
            itemToEdit.data[propertyName] = newValue;
        }
        setGetBooksVocab(updatedData)
    }

    function editDataPropertyStd(targetId, newValue, propertyName) {
        const itemToEdit = getBooksVocabStd.find(item => item.id === targetId);
        const updatedData = getBooksVocabStd.map((item) =>
            item.id === targetId
                ? {
                    ...item,
                    data: {
                        ...item.data,
                        [propertyName]: newValue,
                    },
                }
                : item
        );
        if (itemToEdit) {
            if(typeof itemToEdit.data === 'undefined'){
                itemToEdit.data = {};
            }
            itemToEdit.data[propertyName] = newValue;
        }
        setGetBooksVocabStd(updatedData)
    }

    const trimNumbersFromWord = (str) => {
        if (typeof str !== 'string') return str ?? '';
        return str.trim().replace(/\s*\d+$/, '').trim();
    };
    const handleAddVocData = (key, value) => {
        if (key == 'word') {
            const v = addVocabData;
            addVocabData[key] = trimNumbersFromWord(value);
            setAddVocabData(v);
        } else {
            const v = vocabularyAI;
            vocabularyAI[key] = value;
            setVocabularyAI(v);
        }
    }
    const addVocabulary = (vocabData) => {
        const dataToAdd = vocabData ? vocabData : vocabularyAI
        const dataVocab = {
            book_id: bookId,
            page: pageId,
            chapter: bookId,
            created_by: currentUser?.role,
            user_id: get(currentUser, 'id', ''),
            class_id: get(currentClass, 'id', ''),
            data: {
                word: addVocabData.word,
                ...dataToAdd
            },
        };
        const result = dispatch(handleCreateVocabulary(dataVocab));
        setAlertSakeBar({
            open: true,
            message: "Created Successfully",
            severity: "success",
        })
        if (result) {
            setAddVocabData({})
            setVocabularyAI({})
        }
    }

    const callVocAI = async (initalAttempt = 0, maxAttempts = 2) => {
      if (addVocabData?.word) {
        setShowWordLoader(true);
        const ckeck_word = await checkInappropriateContent(addVocabData?.word, 'vocabulary');
        if (ckeck_word.containsInappropriate) {
          setShowWordLoader(false);
          handleAddInappropriateAlert(
            ckeck_word.foundWords,
            currentUser,
            currentClass,
            'vocabulary',
            addVocabData?.word,
          );
          return showAlert(
            `This word is not available in the dictionary. Please, try another word.`,
            'info',
          );
        }
        if (initalAttempt < maxAttempts) {
          const result = await dispatch(
            handleGenerateVocabularyWithAI({
              topic: addVocabData?.word,
              book_id: bookId,
              page: pageId,
              chapter: bookId,
              created_by: currentUser?.role,
              user_id: get(currentUser, 'id', ''),
              class_id: get(currentClass, 'id', ''),
            }),
          );

          if (!result?.valid && result?.valid !== undefined) {
            showAlert('Some Fields are missing in the response. Trying one more attempt', 'error');
            await callVocAI(initalAttempt + 1, maxAttempts);
          }

          if (result && !result.error) {
            setAlertSakeBar({
              open: true,
              message: 'Created Successfully',
              severity: 'success',
            });
            if (vocabdomRef.current) {
              vocabdomRef.current.scrollTo(0, vocabdomRef.current.scrollHeight);
            }
          } else {
            setAlertSakeBar({
              open: true,
              message: 'No Result Found',
              severity: 'error',
            });
          }
        }else{
            showAlert('Please try with differnet word!', 'info');
        }

        setAddVocabData({});
        setShowWordLoader(false);
      }
    };
    

    const addNewItem = () => {
        const editableItemIndex = getBooksVocab.findIndex(item => item.isEditable);
        if (editableItemIndex !== -1) {
            const pageOfEditableItem = Math.ceil((editableItemIndex + 1) / itemsPerPage);
            setCurrentPage(pageOfEditableItem);
        } else {
            const updatedData = [...getBooksVocab, newItem];
            setGetBooksVocab(updatedData);
            const newItemIndex = updatedData.length - 1;
            const newPage = Math.ceil((newItemIndex + 1) / itemsPerPage);
            if (newPage > currentPage) {
                setCurrentPage(newPage);
            }
        }
    };

    const addNewItemForStd = () => {
        const editableItemIndex = getBooksVocabStd.findIndex(item => item.isEditable);
        if (editableItemIndex !== -1) {
            const pageOfEditableItem = Math.ceil((editableItemIndex + 1) / itemsPerPage);
            setCurrentPageStd(pageOfEditableItem);
        } else {
            const updatedData = [...getBooksVocabStd, newItem];
            setGetBooksVocabStd(updatedData);
            const newItemIndex = updatedData.length - 1;
            const newPage = Math.ceil((newItemIndex + 1) / itemsPerPage);
            if (newPage > currentPageStd) {
                setCurrentPageStd(newPage);
            }
        }
    };

    const handleForDistrictAdmin = () => {
        if (currentUser.role === 'admin') {
            setAlertSakeBar({ open: true, message: 'Please login as teacher!' , severity: "error"});
            return true;
        }
        return false;
    }
    const handleAIBeforeAddNewItem = () => {
        if (!isAiPermissionEnabled) {
            showAlert(currentUser.role === 'student' ? 'Please ask teacher to enable AI permission to add new item.' : 'Please enable AI permission to add new item.', 'error');
            return true;
        }
        return false;
    }

 

    const fetchStudentWordCounts = async (pageSpecific = true) => {
      try {
        const classId = get(currentClass, 'id');

        if (!classId || !bookId) {
          console.warn('Missing required parameters:', { classId, bookId });
          setStudentWordCounts([]);
          return [];
        }

        const data = {
          class_id: classId,
          book_id: bookId,
          ...(pageSpecific && { page: pageId }),
        };

        const counts = await dispatch(handleGetStudentWordCount(data));
        if (Array.isArray(counts)) {
          setStudentWordCounts(counts);
          return counts;
        } else {
          console.warn('Student word counts API returned non-array data:', counts);
          setStudentWordCounts([]);
          return [];
        }
      } catch (error) {
        console.error('Error fetching student word counts:', error);
        setStudentWordCounts([]);
        return [];
      }
    };


    const onCallStudentVocab = async (id, type) => {
        if (!isAiPermissionEnabled) {
          showAlert(currentUser.role === 'student' ? 'Please ask teacher to enable AI permission to generate content using AI.' : 'Please enable AI permission to generate content using AI.', 'error');
          return;
        }
        const targetTab = type === 'vocabulary' ? 'my_vocab_stud' : 'my_student_cog';
        setVocLoader(true)
        const data = {
            teacher_id: get(currentUser, "id", ''),
            user_id: id,
            created_by: 'teacher_student',
            page: pageId,
            book_id: bookId
        }
        try {
            if (type === 'vocabulary') {
                const selectedStudentData = await dispatch(handleListVocabularyStud(data, bookId, pageId, currentUser?.id));
                const vocabList = Array.isArray(selectedStudentData) ? selectedStudentData : [];
                if (tabSelectorTypeRef.current !== targetTab) {
                    return;
                }
                setGetBooksVocab(vocabList);
                setSelectedAIVocab(vocabList);
                setCurrentPage(1);
            } else {
                const selectedStudentCognate = await dispatch(handleListVocabularyCogStud(data, bookId, pageId, currentUser?.id));
                const cognateList = Array.isArray(selectedStudentCognate) ? selectedStudentCognate : [];
                if (tabSelectorTypeRef.current !== targetTab) {
                    return;
                }
                setStudentCognates(cognateList);
                setSelectedWordCogantes(cognateList);
            }
        } finally {
            setVocLoader(false);
        }
    }
    const getStudentWordCount = (studentId) => {
        if (!Array.isArray(studentWordCounts)) {
            return 0;
        }
        const student = studentWordCounts.find(s => s.id === studentId);
        return student ? student.word_count : 0;
    };

    const items = (classStudents && Array.isArray(classStudents)) ? classStudents?.map((item) => {
        const wordCount = getStudentWordCount(item.id);
        return {
            key: item.id,
            label: (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <span>{`${item.firstName} ${item.lastName}`}</span>
                    <span style={{
                        backgroundColor: '#5d4187',
                        color: 'white',
                        borderRadius: '12px',
                        padding: '2px 8px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        minWidth: '20px',
                        textAlign: 'center',
                        marginLeft: '8px'
                    }}>
                        {wordCount}
                    </span>
                </div>
            ),
            wordCount: wordCount
        };
    }).sort((a, b) => b.wordCount - a.wordCount) : [];
    
    const StudentVocabulary = ({ type }) => {
        const [isOpen, setIsOpen] = useState(false);
        const dropdownRef = useRef(null);
        const touchStartY = useRef(null);
        const isScrolling = useRef(false);
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                    const target = event.target;
                    const isDropdownButton = target.closest('button.minWith') || 
                                           target.closest('[data-dropdown="true"]') ||
                                           target.closest('.dropdown-scrollable');
                    if (!isDropdownButton) {
                        setIsOpen(false);
                    }
                }
            };

            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, []);

        const handleTouchStart = (e) => {
            touchStartY.current = e.touches[0].clientY;
            isScrolling.current = false;
        };

        const handleTouchMove = (e) => {
            if (touchStartY.current !== null) {
                const deltaY = Math.abs(e.touches[0].clientY - touchStartY.current);
                if (deltaY > 5) {
                    isScrolling.current = true;
                }
            }
        };

        const handleItemClick = (key, e) => {
            if (isScrolling.current && e && e.type === 'touchstart') {
                return;
            }
            toogleChange(type === 'vocabulary' ? 'my_vocab_stud' : 'my_student_cog');
            onCallStudentVocab(key, type);
            setIsOpen(false);
        };

        return (
            <div ref={dropdownRef} style={{ position: 'relative' }}>
                <Button
                    className={`minWith ${tabSelector?.type === (type === 'vocabulary' ? "my_vocab_stud" : "my_student_cog") ? 'selected selected-background-color' : ''}`}
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {type === 'vocabulary' ? "Student Vocab" : "Student Cognates"}
                    {isOpen ? (
                        <KeyboardArrowUp style={{ marginRight: -5 }} />
                    ) : (
                        <KeyboardArrowDown style={{ marginRight: -5 }} />
                    )}
                </Button>
                
                {isOpen && (
                    <div 
                        data-dropdown="true"
                        className="dropdown-scrollable"
                        style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            backgroundColor: '#fff',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            borderRadius: '4px',
                            zIndex: 1000000002,
                            minWidth: '200px',
                            maxHeight: '200px',
                            overflowY: 'auto',
                            WebkitOverflowScrolling: 'touch',
                            touchAction: 'pan-y'
                        }}
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                    >
                        {items.length > 0 ? items.map((item) => (
                            <div
                                key={item.key}
                                onClick={(e) => handleItemClick(item.key, e)}
                                onTouchEnd={(e) => {
                                    if (!isScrolling.current) {
                                        handleItemClick(item.key, e);
                                    }
                                    touchStartY.current = null;
                                    isScrolling.current = false;
                                }}
                                style={{
                                    padding: '8px 12px',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    touchAction: 'pan-y',
                                    WebkitTouchCallout: 'none',
                                    userSelect: 'none',
                                    ':hover': {
                                        backgroundColor: '#f5f5f5'
                                    }
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                            >
                                {item.label}
                                <span style={{
                                    backgroundColor: '#5d4187',
                                    color: 'white',
                                    borderRadius: '12px',
                                    padding: '2px 8px',
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    minWidth: '20px',
                                    textAlign: 'center'
                                }}>
                                    {item.wordCount}
                                </span>
                            </div>
                        )) : (
                            <div style={{ padding: '8px 12px', color: '#666' }}>
                                No students found
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    };

    const findPageObject = (pageID, data) => {
        return data.find(
            item => Number(pageID) >= Number(item?.startPage) && Number(pageID) <= Number(item?.finishPage)
        );
    };

    const onManageVocabMenu = async (id, type) => {
        if (id === 'page_vocabulary') {
            toogleChange("page_vocab");
            setGetBooksVocab(newBooksVocab);
            setSelectedAIVocab(newBooksVocab || []);
            setCurrentPage(1);
        } else if (id === 'unit_vocabulary') {
            if (current_book?.length === 0) {
                showAlert('Unit not found in this book.', "info");
                return;
            }
            toogleChange("unit_vocabulary");
            const findUnit = findPageObject(pageId, current_book);
            const filteredData = bookVocabulary.filter(item => {
                const pageNumber = parseInt(item.page, 10);
                return pageNumber >= parseInt(findUnit?.startPage, 10) && pageNumber <= parseInt(findUnit?.finishPage, 10);
            });
            const filterByAdmin = filteredData?.filter(data => data?.created_by === "owe_admin") || [];
            const filterByTeacher = filteredData?.filter(data => data?.created_by === "teacher") || [];
            const data = [];
            if (filterByAdmin?.length > 0) data.push(...filterByAdmin);
            if (filterByTeacher?.length > 0) data.push(...filterByTeacher);
            setGetBooksVocab(data);
            setSelectedAIVocab(data || []);
            setCurrentPage(1);
        }
    }


    const unitExists = location.pathname === "/ebook" && findPageObject(pageId, current_book);
    const RenderMenuContent = () => {
    
        const menuItems = [
            ...(get(currentUser, "role") === "teacher" ? [{
                key: 'page_vocabulary',
                label: 'Page Vocab',
                onClick: () => onManageVocabMenu('page_vocabulary')
            }] : []),
            ...(get(currentUser, "role") === "teacher" && unitExists ? [{
                key: 'unit_vocabulary',
                label: 'Unit Vocab',
                onClick: () => onManageVocabMenu('unit_vocabulary')
            }] : []),
            ...(get(currentUser, "role") === "teacher" && !isExam && !isOnlyForTeacher ? [{
                key: 'ai_activity_vocab',
                label: 'AI Act. with Vocab',
                onClick: handleCreateVocabularyQnA
            }] : []),
            ...(get(currentUser, "role") === "student" ? [{
                key: 'page_vocab',
                label: 'Page Vocab',
                onClick: () => toogleChange("page_vocab")
            }] : []),
            ...(get(currentUser, "role") === "student" ? [{
                key: 'my_vocab',
                label: 'My Vocab',
                onClick: () => toogleChange("my_vocab")
            }] : []),
        ];
    
        return menuItems.map(item => ({
            key: item.key,
            label: <div onClick={item.onClick}>{item.label}</div>
        }));
    };
    


    const [visible, setVisible] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState('spanish');
    const handleMenuClick = (e) => {
        // Prevent closing the dropdown on first menu click
        if (e.key === '1') {
            setVisible(true);  // Keep the dropdown open if the first item is clicked
        } else {
            setVisible(false); // Close dropdown for other menu items
        }
    };

    const DROPDOWN_Z_INDEX = 1000000001;
    const languageMenuItems = [
        {
            key: 'spanish',
            label: 'Spanish'
        },
        {
            key: 'english',
            label: 'English'
        }
    ];

    const handleLanguageChange = ({ key }) => {
        handleCreateVocabularyQnA(null,0,1,key)
    };

    const handleItemClickStudentVocab = (key) => {
        toogleChange('my_vocab_stud');
        onCallStudentVocab(key?.key, 'vocabulary');
    };

    return (
    <SentryWrap>
        <div ref={ref} tabIndex={0}>
            <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={alertSakeBar.open}
            autoHideDuration={3000}
            onClose={closeAlert}>
            <Alert onClose={() => { setAlertSakeBar({ open: false, message: '' }) }} severity={alertSakeBar.severity}>
                <strong>ALERT:</strong> {alertSakeBar.message}
            </Alert>
        </Snackbar>
        <CognateAiLoader aiModal={aiModal} />
        <DeleteModal
            deleteToggle={deleteModal}
            loading={deleteVoc}
            onDelete={() => {
                onDeleteVocab()
                setDeleteVoc(true);
            }}
            setDeleteToggle={setDeleteModal}
            message={`Are you sure you want to remove this ${deleteVocab?.data && deleteVocab?.data?.word ? `"${deleteVocab.data.word}"` : ''} vocabulary?`}
        />

        {/* {isVocabularyAllowedForBookGroup && ( */}
            <Button style={{borderRadius:"0px !important" , minWidth: "unset",height: "36px", marginLeft: currentUser?.role === 'student' && 0 , ...(style?style:{})}}
                onClick={() => {
                    closeToolsDropdown();
                    setVocabulary(!openVocabulary);
                    setSelectedAIVocab(getBooksVocab || []);
                    if (currentUser?.role === 'teacher') {
                      const isPageSpecific =
                        tabSelector?.type === 'page_vocab' || tabSelector?.type === 'my_vocab_stud';
                      fetchStudentWordCounts(isPageSpecific);
                    }
                }}
                // className={`vocabularyBtn vocDeskTab scheduledWeb ${vocabilaryButtonClassName}`}
                className={`${isVocabulary ? 'videoSectionVocab' : `vocabularyBtn vocDeskTab scheduledWeb ${vocabilaryButtonClassName}`}`}
                >vocabulary</Button>
        {/* )} */}
        {openVocabulary && (
                <ResizeAndDragabble
                  style={{zIndex: 1000000000}}
                    defaultValue={{
                        x: windowSize?.width < 768 ? (windowSize?.width - windowSize?.width * 0.7) / 2 : (windowSize?.width - Math.min(windowSize?.width - 40, 700)) / 2,
                        y: windowSize?.height < 600 ? 10 : (windowSize?.height - Math.min(windowSize?.height - 40, 500)) / 2,
                        width: windowSize?.width < 768 ? windowSize?.width * 0.7 : Math.min(windowSize?.width - 40, 700),
                        height: windowSize?.height < 600 ? windowSize?.height * 0.7 : Math.min(windowSize?.height - 40, 500),
                    }}
                    size={dimensions?.width && dimensions?.height ? dimensions : undefined}
                    minHeight={200}
                    minWidth={windowSize?.width < 768 ? windowSize?.width * 0.5 : 300}
                    maxWidth={windowSize?.width < 768 ? windowSize?.width : windowSize?.width - 40}
                    maxHeight={windowSize?.width < 768 ? windowSize?.height * 0.8 : windowSize?.height - 60}
                    resize={(data) => setDimensions(data)}
                    resizeEnd={(data) => setDimensions(data)}
                    aspectRatio={false}
                    showAccordin={showAccordin}
                    center={false}
                >
                    <ModalContent isLandscape={isLandscape} className='111 vocabulContents vocabulContentsWidget' style={{
                        boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px",
                        zIndex: 1000000002,
                        position: "relative"
                    }}>
                        <div className="checkListFirstTxt absolute top-0 w-full pt-17px pb-14px br-topLeft-topRight-20px" style={{ pointerEvents: 'none' }}>
                            <span className="text-white text-ft12-700 vocabularyTrack">Vocabulary</span>
                        </div>
                                <CrossPrint style={{ pointerEvents: 'auto' }}>
                                    <div style={{ position: 'relative'}}>
                                        <AIUsageInfo />
                                    </div>
                                    {get(currentUser, 'role') === 'teacher' && tabSelector?.type !== 'translation' && (
                                        <VocabPrint data={tabSelector?.type === 'congantes' ? selectedWordCogantes : tabSelector?.type === 'unit_cognates' ? studentCognates : tabSelector?.type === 'my_student_cog' ? studentCognates : getBooksVocab} toggleType={tabSelector?.type} />
                                    )}
                                    <Close color="secondary" onClick={handleVocabularyClose} className='vocablaryClose' />
                                </CrossPrint>
                        <div className='VocabularyTabWidget VocabularyTab FirstVocabularyTab flex items-stretch gap-5px flex-wrap mr-26px' style={{ pointerEvents: 'auto' }}>
                            {/* Teacher View */}
                                {get(currentUser, 'role') === 'teacher' && location.pathname === "/ebook" ? <AllVocabulary type={""} tabSelector={tabSelector} onManageVocabMenu={onManageVocabMenu}  unitExists={unitExists} /> : <Button className={tabSelector?.type === "page_vocab" ? 'selected selected-background-color' : ''}
                                    onClick={() => {
                                        onManageVocabMenu('page_vocabulary');
                                        toogleChange("page_vocab")
                                    }}>
                                    Page Vocab
                                </Button> }    
                                {get(currentUser, "role") === "teacher" && !isExam && !isOnlyForTeacher && (
                                       <Dropdown
                                       menu={{ items: languageMenuItems, onClick: handleLanguageChange }}
                                       trigger={['click']}
                                       placement="bottomRight"
                                       overlayStyle={{ zIndex: DROPDOWN_Z_INDEX }}
                                       getPopupContainer={() => document.body}
                                   >
                                       <Button className='create-with-ai-button minWith'>
                                            AI Act. with Vocab
                                           <KeyboardArrowDown />
                                       </Button>
                                   </Dropdown>
                                )}
                            {/* {get(currentUser, 'role') === 'teacher' && <StudentVocabulary type='vocabulary' />} */}
                            {get(currentUser, 'role') === 'teacher' &&  (
                                <Dropdown
                                   menu={{ items: items, onClick: handleItemClickStudentVocab }}
                                    trigger={['click']}
                                    placement="bottomRight"
                                    overlayStyle={{ zIndex: DROPDOWN_Z_INDEX }}
                                    getPopupContainer={() => document.body}
                                    dropdownRender={(menu) => (
                                        <div style={{ maxHeight: '220px', overflowY: 'auto', borderRadius: 8 }}>
                                            {menu}
                                        </div>
                                    )}
                                >
                                    <Button className={`minWith ${tabSelector?.type === 'my_vocab_stud' ? 'selected selected-background-color' : ''}`}>
                                    Student Vocab
                                        <KeyboardArrowDown />
                                    </Button>
                                </Dropdown>
                            )}
                            {get(currentUser, "role") === "student" && (
                                <Button className={tabSelector?.type === "my_vocab" ? 'selected selected-background-color' : ''}
                                    onClick={() => toogleChange("my_vocab")}>
                                    My Vocabulary
                                </Button>
                            )}
                            {get(currentUser, "role") === "student" && (
                                <Button className={tabSelector?.type === "other_students_vocab" ? 'selected selected-background-color' : ''}
                                    onClick={() => toogleChange("other_students_vocab")}>
                                    Class Vocab
                                </Button>
                            )}
                            {(get(currentUser, 'role') === 'teacher' || get(currentUser, 'role') === 'student') && (
                                <Button
                                    className={`minWith ${tabSelector?.type === 'translation' ? 'selected selected-background-color' : ''}`}
                                    onClick={() => toogleChange('translation')}
                                >
                                    Word Translation
                                </Button>
                            )}
                        </div>
                    <div className='111 vocabulTableUpr vocab-table-upar vocabStrokeWidth vocInMobile vocInMobileWidget dropdown-scrollable cursor-default' data-dropdown="true" ref={vocabdomRef}>

                    {tabSelector?.type === 'translation' && (
                        <WordTranslationTable pageId={pageId} bookId={bookId} />
                    )}

                    {(tabSelector?.type === "page_vocab" || tabSelector?.type === "my_vocab_stud" || tabSelector?.type === 'unit_vocabulary') && (
                        <>
                            <StyledTable border className='vocabulTable'>
                            <thead>
                                <StyledHeader className='vocabulHeadTh'>
                                    {get(currentUser, "role") === "teacher" && !isExam && <StyledTh>Check</StyledTh>}
                                    <StyledTh style={{ minWidth: 150, maxWidth: 250 }}>Word</StyledTh>
                                    <StyledTh style={{ minWidth: 150 }}>English translation</StyledTh>
                                    <StyledTh>Definition</StyledTh>
                                    <StyledTh style={{ minWidth: 200 }}>Synonyms</StyledTh>
                                    <StyledTh style={{ minWidth: 200 }}>Antonyms</StyledTh>
                                    <StyledTh>Sentence in Spanish</StyledTh>
                                    {/* <th>Sentence in English</th> */}
                                    <StyledTh>Actions</StyledTh>
                                </StyledHeader>
                            </thead>
                                {vocLoader ? (
                                    <tbody>
                                        <tr>
                                            <td colSpan={get(currentUser, "role") === "teacher" && !isExam ? 8 : 7}>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60px' }}>
                                                    <Loading size={28} style={{ color:'#022b70'}} />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                ) : (
                                <>
                                {map(
                                    (tabSelector?.type === 'my_vocab_stud'
                                        ? sortBy(
                                            getBooksVocab,
                                            o => (o.data && typeof o.data.word === 'string') ? o.data.word.toLowerCase().trim() : ''
                                        )
                                        : getBooksVocab
                                    ).slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage),
                                    (value, k) => {
                                    let data = get(value, 'data', '')
                                    if (value?.created_by == 'student' && tabSelector?.type !== "my_vocab_stud" ) return
                                    const actualIndex = (currentPage - 1) * itemsPerPage + k;
                                    return (
                                        <tr className='vocabulHeadTr vocIcons' key={`${value.id || 'row'}-${actualIndex}`}>
                                            {get(currentUser, "role") === "teacher" && !isExam &&
                                                <td style={{ textAlign: 'center' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <Checkbox
                                                            disabled={!data?.word}
                                                            onChange={(e) => handleCheckboxChange(e.target.checked, value)}
                                                            checked={selectedAIVocabIds.has(value.id)}
                                                            defaultChecked={true}
                                                        />
                                                    </div>
                                                </td>
                                            }
                                            <td style={{ minWidth: 150, maxWidth: 250 }}>
                                                {value?.isEditable == true ? (
                                                    <div className='vocabInput'>
                                                        <InputArea
                                                            onPressEnter={() => {
                                                                if (!showWordLoader) {
                                                                    callVocAI();
                                                                }

                                                            }}
                                                            disabled={tabSelector?.type === "my_vocab_stud"}
                                                            onChange={(d) => { handleAddVocData('word', d.target.value.trimStart()) }}
                                                            placeholder='word'
                                                            autoSize
                                                            autoFocus
                                                            style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200 }}
                                                        />
                                                        <div style={{ position: 'absolute', top: 6, right: 4 }}>
                                                            {showWordLoader ? <Loading size={17} /> : <EnterOutlined disabled={showWordLoader} onClick={() => {
                                                                if (!showWordLoader) {
                                                                    callVocAI();
                                                                }

                                                            }} style={{ fontSize: '25px' }} />}
                                                        </div>
                                                    </div>
                                                ) : (<>
                                                    <TextReader stopAudio={stopAudio} text={get(data, 'word', '')} language={"es-ES"} style={{ float: "right" }} />
                                                    <InputArea
                                                        disabled={value?.created_by === 'owe_admin' || (currentUser?.role === 'student' || value?.created_by === 'teacher') || tabSelector?.type === "my_vocab_stud"}
                                                        value={get(data, 'word', '')}
                                                        onChange={(d) => editDataProperty(value.id, d.target.value.trimStart(), 'word')}
                                                        placeholder='word'
                                                        autoSize
                                                        autoFocus
                                                        style={{ width: 150, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200 }}
                                                    />

                                                </>
                                                )}
                                            </td>
                                            <td>
                                                <TextReader stopAudio={stopAudio} text={get(data, 'english_translation', '')} language={"en-US"} style={{ float: "right" }} />
                                                <TextArea
                                                    onBlur={() => {
                                                        handleUpdateData(value, 'english_translation')
                                                    }}
                                                    onFocus={() => handleFocus(get(data, 'english_translation', ''))}
                                                    disabled={(currentUser?.role === 'student' && value?.created_by === 'owe_admin') || (currentUser?.role === 'student' && value?.created_by === 'teacher') || tabSelector?.type === "my_vocab_stud"}
                                                    value={get(data, 'english_translation', '')}
                                                    onChange={(d) => editDataProperty(value.id, d.target.value.trimStart(), 'english_translation')}
                                                    autoSize
                                                    style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                                                />

                                            </td>
                                            <td>
                                                <TextReader stopAudio={stopAudio} text={get(data, 'definition', '')} language={"es-ES"} style={{ float: "right" }} />
                                                <TextArea
                                                    onBlur={() => {
                                                        handleUpdateData(value, 'definition')
                                                    }}
                                                    onFocus={() => handleFocus(get(data, 'definition', ''))}
                                                    disabled={(currentUser?.role === 'student' && value?.created_by === 'owe_admin') || (currentUser?.role === 'student' && value?.created_by === 'teacher') || tabSelector?.type === "my_vocab_stud"}
                                                    value={get(data, 'definition', '')}
                                                    onChange={(d) => editDataProperty(value.id, d.target.value.trimStart(), 'definition')}
                                                    autoSize
                                                    style={{ width: 200, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                                                />
                                            </td>
                                            <td>
                                                <TextReader stopAudio={stopAudio} text={formatValueDisplayForVocab(get(data, 'synonyms', ''))} language={"es-ES"} style={{ float: "right" }} />
                                                <TextArea
                                                    onBlur={() => {
                                                        handleUpdateData(value, 'synonyms')
                                                    }}
                                                    onFocus={() => handleFocus(formatValueDisplayForVocab(get(data, 'synonyms', '')))}
                                                    disabled={(currentUser?.role === 'student' && value?.created_by === 'owe_admin') || (currentUser?.role === 'student' && value?.created_by === 'teacher') || tabSelector?.type === "my_vocab_stud"}
                                                    value={formatValueDisplayForVocab(get(data, 'synonyms', ''))}
                                                    onChange={(d) => editDataProperty(value.id, d.target.value.trimStart(), 'synonyms')}
                                                    autoSize
                                                    style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                                                />
                                            </td>
                                            <td>
                                                <TextReader stopAudio={stopAudio} text={formatValueDisplayForVocab(get(data, 'antonyms', ''))} language={"es-ES"} style={{ float: "right" }} />
                                                <TextArea
                                                    onBlur={() => {
                                                        handleUpdateData(value, 'antonyms')
                                                    }}
                                                    onFocus={() => handleFocus(formatValueDisplayForVocab(get(data, 'antonyms', '')))}
                                                    disabled={(currentUser?.role === 'student' && value?.created_by === 'owe_admin') ||(currentUser?.role === 'student' && value?.created_by === 'teacher') || tabSelector?.type === "my_vocab_stud"}
                                                    value={formatValueDisplayForVocab(get(data, 'antonyms', ''))}
                                                    onChange={(d) => editDataProperty(value.id, d.target.value.trimStart(), 'antonyms')}
                                                    autoSize
                                                    style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                                                />
                                            </td>
                                            <td
                                            >
                                                <TextReader stopAudio={stopAudio} text={get(data, 'sentence', '')} language={"es-ES"} style={{ float: "right" }} />
                                                <TextArea
                                                    onBlur={() => {
                                                        handleUpdateData(value, 'sentence')
                                                    }}
                                                    onFocus={() => handleFocus(get(data, 'sentence', ''))}
                                                    disabled={(currentUser?.role === 'student' && value?.created_by === 'owe_admin') || (currentUser?.role === 'student' && value?.created_by === 'teacher') || tabSelector?.type === "my_vocab_stud"}
                                                    value={get(data, 'sentence', '')}
                                                    onChange={(d) => editDataProperty(value.id, d.target.value.trimStart(), 'sentence')}
                                                    autoSize
                                                    style={{ width: 200, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                                                />
                                            </td>
                                            {get(currentUser, "role") == "student" ? (
                                                <>
                                                    <td style={{ textAlign: 'center' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <ActionText>
                                                                {value?.created_by === 'owe_admin' ? 'Admin' : 'Teacher'}
                                                            </ActionText>
                                                        </div>
                                                    </td>
                                                </>

                                            ) : (
                                                <>
                                                    {value?.created_by !== 'owe_admin' && tabSelector?.type !== "my_vocab_stud" ? (
                                                        <td style={{ textAlign: 'center' }}>
                                                            {data?.word ? (
                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <Delete style={{ fontSize: '20px' }} onClick={() => {
                                                                        setDeleteModal(true);
                                                                        setDeleteVocab(value);
                                                                    }} />
                                                                </div>
                                                            ) : null}
                                                        </td>
                                                    ) : tabSelector?.type === "my_vocab_stud" ? (
                                                        <td style={{ textAlign: 'center' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                <ActionText>Student</ActionText>
                                                            </div>
                                                        </td>
                                                    ) : (
                                                        <td style={{ textAlign: 'center' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                <ActionText>Admin</ActionText>
                                                            </div>
                                                        </td>
                                                    )}
                                                </>
                                            )}
                                        </tr>
                                    )
                                })}
                        </>
                                )}
                                {get(currentUser, "role") !== "student" && tabSelector?.type !== "my_vocab_stud" && tabSelector?.type !== 'unit_vocabulary' && (
                                    <tr className='vocabulHeadTr'>
                                        {get(currentUser, "role") === "teacher" && !isExam && <td></td>}
                                        <td>
                                            <IconButton>
                                                <Add style={{ fontSize: '18px' }} onClick={() => {
                                                    if (handleForDistrictAdmin()) return;
                                                    if (handleAIBeforeAddNewItem()) return;
                                                    addNewItem()
                                                }} />
                                            </IconButton>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                )}
                            {vocLoader ? (
                                <Loading size={28} style={{ color:'#022b70'}} />
                            ) : <>
                                { getBooksVocab?.length === 0 && (
                                <tr>
                                    <td colSpan={get(currentUser, "role") === "teacher" && !isExam ? 8 : 7} style={{ border: 'none' }}>
                                        <p style={{ fontWeight: 200, paddingTop: '5px', display: 'flex', justifyContent: 'center' }}>No vocabulary available in this section.</p>
                                    </td>
                                </tr>
                                )}
                            </>
                        }
                            </StyledTable>
                            {getBooksVocab.length > itemsPerPage && (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', padding: '15px', marginTop: '15px' }}>
                                    <IconButton 
                                        disabled={currentPage === 1}
                                        onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                                        size="small"
                                        style={{ color: 'white' }}
                                    >
                                        <ChevronLeft />
                                    </IconButton>
                                    <span style={{ color: 'white', fontSize: '14px', minWidth: '150px', textAlign: 'center' }}>
                                        Page {currentPage} of {Math.ceil(getBooksVocab.length / itemsPerPage)} ({getBooksVocab.length} items)
                                    </span>
                                    <IconButton 
                                        disabled={currentPage >= Math.ceil(getBooksVocab.length / itemsPerPage)}
                                        onClick={() => setCurrentPage(prev => Math.min(Math.ceil(getBooksVocab.length / itemsPerPage), prev + 1))}
                                        size="small"
                                        style={{ color: 'white' }}
                                    >
                                        <ChevronRight />
                                    </IconButton>
                                </div>
                            )}
                        </>
                    )}

                    {tabSelector?.type === "my_vocab" && get(currentUser, "role") === "student" && (
                    <>
                        <StyledTable border className='vocabulTable'>
                            <StyledHeader className='vocabulHeadTh'>
                                <StyledTh style={{ minWidth:150, maxWidth:250 }}>Word</StyledTh>
                                <StyledTh style={{ minWidth:150}}>English translation</StyledTh>
                                <StyledTh>Definition</StyledTh>
                                <StyledTh style={{ minWidth:200 }} >Synonyms</StyledTh>
                                <StyledTh style={{ minWidth:200 }}>Antonyms</StyledTh>
                                <StyledTh>Sentence in Spanish</StyledTh>
                                {/* <th>Sentence in English</th> */}
                                <StyledTh>Actions</StyledTh>
                            </StyledHeader>
                            {vocLoader ? (
                                <tbody>
                                    <tr>
                                        <td colSpan={2} style={{ border: 'none'}}>
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60px' }}>
                                                <Loading size={28} style={{ color:'#022b70'}} />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            ) : (
                        <>
                            {map(getBooksVocabStd.slice((currentPageStd - 1) * itemsPerPage, currentPageStd * itemsPerPage), (value, k) => {
                                let data = get(value, 'data', '')
                                const actualIndex = (currentPageStd - 1) * itemsPerPage + k;
                                return (
                                    <tr className='vocabulHeadTr vocIcons' key={value.id || actualIndex}>
                                         <td  style={{ minWidth:150, maxWidth:250}}>
                                            {value?.isEditable == true ? (
                                                <div className='vocabInput'>
                                                    <InputArea
                                                        onPressEnter={() => {
                                                            if(!showWordLoader){
                                                            callVocAI();                                             
                                                            }
                                                        }}
                                                        onChange={(d) => { handleAddVocData('word', d.target.value.trimStart()) }}
                                                        placeholder='word'
                                                        autoSize
                                                        autoFocus
                                                        style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200 }}
                                                    />
                                                    <div style={{ position: 'absolute', top: 6, right: 4 }}>
                                                        {showWordLoader ? <Loading size={17} /> : <EnterOutlined disabled={showWordLoader} onClick={() => {
                                                            if(!showWordLoader){
                                                                callVocAI();       
                                                            }
                                                        }} style={{ fontSize: '25px' }} />}
                                                    </div>
                                                </div>
                                            ) : (<>
                                             <TextReader stopAudio={stopAudio}  text={get(data, 'word', '')} language={"es-ES"} style={{ float: "right" }} />
                                                <InputArea
                                                    disabled={currentUser?.role === 'student' || value?.created_by === 'owe_admin' || value?.created_by === 'teacher'}
                                                    value={get(data, 'word', '')}
                                                    onChange={(d) => editDataPropertyStd(value.id, d.target.value.trimStart(), 'word')}
                                                    placeholder='word'
                                                    autoSize
                                                    style={{ width: 150, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200 }}
                                                />
                                               
                                            </>
                                            )}
                                        </td>
                                        <td>

                                        <TextReader stopAudio={stopAudio}  text={get(data, 'english_translation', '')} language={"en-US"}  style={{ float:"right"}} />
                                            <TextArea
                                                onBlur={() => {
                                                    handleUpdateDataStd(value, 'english_translation')
                                                }}
                                                onFocus={() => handleFocusStd(get(data, 'english_translation', ''))}
                                                disabled={currentUser?.role === 'student' || is_vocab_block_edit || !isVocabularyAllowedForBookGroup}
                                                value={get(data, 'english_translation', '')}
                                                onChange={(d) => editDataPropertyStd(value.id, d.target.value.trimStart(), 'english_translation')}
                                                autoSize
                                                style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                                            />     
                                        </td>
                                        <td>
                                        <TextReader stopAudio={stopAudio}  text={get(data, 'definition', '')} language={"es-ES"}  style={{ float:"right"}} />
                                            <TextArea
                                                onBlur={() => {
                                                    handleUpdateDataStd(value, 'definition')
                                                }}
                                                onFocus={() => handleFocusStd(get(data, 'definition', ''))}
                                                disabled={currentUser?.role === 'student' || is_vocab_block_edit || !isVocabularyAllowedForBookGroup}
                                                value={get(data, 'definition', '')}
                                                onChange={(d) => editDataPropertyStd(value.id, d.target.value.trimStart(), 'definition')}
                                                autoSize
                                                style={{ width: 200, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                                            />
                                           
                                        </td>
                                        <td>
                                        <TextReader stopAudio={stopAudio}  text={formatValueDisplayForVocab(get(data, 'synonyms', ''))} language={"es-ES"}  style={{ float:"right"}} />
                                            <TextArea
                                                onBlur={() => {
                                                    handleUpdateDataStd(value, 'synonyms')
                                                }}
                                                onFocus={() => handleFocusStd(formatValueDisplayForVocab(get(data, 'synonyms', '')))}
                                                disabled={currentUser?.role === 'student' || is_vocab_block_edit || !isVocabularyAllowedForBookGroup}
                                                value={formatValueDisplayForVocab(get(data, 'synonyms', ''))}
                                                onChange={(d) => editDataPropertyStd(value.id, d.target.value.trimStart(), 'synonyms')}
                                                autoSize
                                                style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                                            />
                                            
                                        </td>
                                        <td>
                                        <TextReader stopAudio={stopAudio} text={formatValueDisplayForVocab(get(data, 'antonyms', ''))} language={"es-ES"}  style={{ float:"right"}} />
                                            <TextArea
                                                onBlur={() => {
                                                    handleUpdateDataStd(value, 'antonyms')
                                                }}
                                                onFocus={() => handleFocusStd(formatValueDisplayForVocab(get(data, 'antonyms', '')))}
                                                disabled={currentUser?.role === 'student' || is_vocab_block_edit || !isVocabularyAllowedForBookGroup}
                                                // disabled={value?.created_by === 'owe_admin' || (currentUser?.role === 'student' && value?.created_by === 'teacher')}
                                                value={formatValueDisplayForVocab(get(data, 'antonyms', ''))}
                                                onChange={(d) => editDataPropertyStd(value.id, d.target.value.trimStart(), 'antonyms')}
                                                autoSize
                                                style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                                            />
                                        </td>
                                        <td>
                                        <TextReader stopAudio={stopAudio} text={get(data, 'sentence', '')} language={"es-ES"}  style={{ float:"right"}} />
                                            <TextArea
                                                onBlur={() => {
                                                    handleUpdateDataStd(value, 'sentence')
                                                }}
                                                onFocus={() => handleFocusStd(get(data, 'sentence', ''))}
                                                disabled={currentUser?.role === 'student' || is_vocab_block_edit || !isVocabularyAllowedForBookGroup}
                                                value={get(data, 'sentence', '')}
                                                onChange={(d) => editDataPropertyStd(value.id, d.target.value.trimStart(), 'sentence')}
                                                autoSize
                                                style={{ width: 200, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                                            />
                                        </td>
                                        {/* <td>
                                        <TextReader text={get(data, 'sentence_english', '')} language={"en-US"}  style={{ float:"right"}} />
                                            <TextArea
                                                onBlur={() => {
                                                    handleUpdateDataStd(value)
                                                }}
                                                value={get(data, 'sentence_english', '')}
                                                onChange={(d) => editDataPropertyStd(value.id, d.target.value.trimStart(), 'sentence_english')}
                                                autoSize
                                                style={{ width: 200, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                                            />
                                        </td> */}
                                        <td style={{ textAlign: 'center' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                {(data?.word && isVocabularyAllowedForBookGroup) && (
                                                    <Delete
                                                        style={{ fontSize: 20 }}
                                                        onClick={() => {
                                                            setDeleteModal(true);
                                                            setDeleteVocab(value);
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                       
                        </>
                    )}
                            <tr className='vocabulHeadTr'>
                                <td><IconButton>
                                   {(!is_vocab_block_edit && isVocabularyAllowedForBookGroup) ? <Add style={{ fontSize: '18px' }} disabled={!isVocabularyAllowedForBookGroup} onClick={() => {
                                         if(handleForDistrictAdmin()) return;
                                         if(handleAIBeforeAddNewItem()) return;
                                        addNewItemForStd()
                                    }} />:null}
                                </IconButton>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        {vocLoader ? (
                                <Loading size={28} style={{ color:'#022b70'}} />
                            ) : <>
                                { getBooksVocabStd?.length === 0 && (
                               <tr>
                                  <td colSpan={7} style={{ border: 'none' }}>
                                    <p style={{ fontWeight: 200, paddingTop: '5px', display: 'flex', justifyContent: 'center' }}>No vocabulary available in this section.</p>
                                  </td>
                               </tr>
                                )}
                            </>
                        }
                </StyledTable>
                {getBooksVocabStd.length > itemsPerPage && (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', padding: '15px', marginTop: '15px' }}>
                        <IconButton 
                            disabled={currentPageStd === 1}
                            onClick={() => setCurrentPageStd(prev => Math.max(1, prev - 1))}
                            size="small"
                            style={{ color: 'white' }}
                        >
                            <ChevronLeft />
                        </IconButton>
                        <span style={{ color: 'white', fontSize: '14px', minWidth: '150px', textAlign: 'center' }}>
                            Page {currentPageStd} of {Math.ceil(getBooksVocabStd.length / itemsPerPage)} ({getBooksVocabStd.length} items)
                        </span>
                        <IconButton 
                            disabled={currentPageStd >= Math.ceil(getBooksVocabStd.length / itemsPerPage)}
                            onClick={() => setCurrentPageStd(prev => Math.min(Math.ceil(getBooksVocabStd.length / itemsPerPage), prev + 1))}
                            size="small"
                            style={{ color: 'white' }}
                        >
                            <ChevronRight />
                        </IconButton>
                    </div>
                )}
              </>
            )}

                    {tabSelector?.type === "other_students_vocab" && get(currentUser, "role") === "student" && (
                    <>
                        <StyledTable border className='vocabulTable'>
                            <StyledHeader className='vocabulHeadTh'>
                                <StyledTh style={{ minWidth:150, maxWidth:250 }}>Word</StyledTh>
                                <StyledTh style={{ minWidth:150}}>English translation</StyledTh>
                                <StyledTh>Definition</StyledTh>
                                <StyledTh style={{ minWidth:200 }} >Synonyms</StyledTh>
                                <StyledTh style={{ minWidth:200 }}>Antonyms</StyledTh>
                                <StyledTh>Sentence in Spanish</StyledTh>
                            </StyledHeader>
                            {vocLoader ? (
                                <tbody>
                                    <tr>
                                        <td colSpan={6} style={{ border: 'none'}}>
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60px' }}>
                                                <Loading size={28} style={{ color:'#022b70'}} />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            ) : (
                        <>
                            {map(getOtherStudentsVocab.slice((currentPageOtherStudents - 1) * itemsPerPage, currentPageOtherStudents * itemsPerPage), (value, k) => {
                                let data = get(value, 'data', '')
                                const actualIndex = (currentPageOtherStudents - 1) * itemsPerPage + k;
                                return (
                                    <tr className='vocabulHeadTr vocIcons' key={value.id || actualIndex}>
                                         <td  style={{ minWidth:150, maxWidth:250}}>
                                             <TextReader stopAudio={stopAudio}  text={get(data, 'word', '')} language={"es-ES"} style={{ float: "right" }} />
                                                <InputArea
                                                    disabled={true}
                                                    value={get(data, 'word', '')}
                                                    placeholder='word'
                                                    autoSize
                                                    style={{ width: 150, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200 }}
                                                />
                                        </td>
                                        <td>
                                        <TextReader stopAudio={stopAudio}  text={get(data, 'english_translation', '')} language={"en-US"}  style={{ float:"right"}} />
                                            <TextArea
                                                disabled={true}
                                                value={get(data, 'english_translation', '')}
                                                autoSize
                                                style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                                            />     
                                        </td>
                                        <td>
                                        <TextReader stopAudio={stopAudio}  text={get(data, 'definition', '')} language={"es-ES"}  style={{ float:"right"}} />
                                            <TextArea
                                                disabled={true}
                                                value={get(data, 'definition', '')}
                                                autoSize
                                                style={{ width: 200, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                                            />
                                        </td>
                                        <td>
                                        <TextReader stopAudio={stopAudio}  text={formatValueDisplayForVocab(get(data, 'synonyms', ''))} language={"es-ES"}  style={{ float:"right"}} />
                                            <TextArea
                                                disabled={true}
                                                value={formatValueDisplayForVocab(get(data, 'synonyms', ''))}
                                                autoSize
                                                style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                                            />
                                        </td>
                                        <td>
                                        <TextReader stopAudio={stopAudio} text={formatValueDisplayForVocab(get(data, 'antonyms', ''))} language={"es-ES"}  style={{ float:"right"}} />
                                            <TextArea
                                                disabled={true}
                                                value={formatValueDisplayForVocab(get(data, 'antonyms', ''))}
                                                autoSize
                                                style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                                            />
                                        </td>
                                        <td>
                                        <TextReader stopAudio={stopAudio} text={get(data, 'sentence', '')} language={"es-ES"}  style={{ float:"right"}} />
                                            <TextArea
                                                disabled={true}
                                                value={get(data, 'sentence', '')}
                                                autoSize
                                                style={{ width: 200, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                                            />
                                        </td>
                                    </tr>
                                )
                            })}
                       
                        </>
                    )}
                        {vocLoader ? (
                                <Loading size={28} style={{ color:'#022b70'}} />
                            ) : <>
                                { getOtherStudentsVocab?.length === 0 && (
                               <tr>
                                  <td colSpan={6} style={{ border: 'none' }}>
                                    <p style={{ fontWeight: 200, paddingTop: '5px', display: 'flex', justifyContent: 'center' }}>No vocabulary available in this section.</p>
                                  </td>
                               </tr>
                                )}
                            </>
                        }
                </StyledTable>
                {getOtherStudentsVocab.length > itemsPerPage && (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', padding: '15px', marginTop: '15px' }}>
                        <IconButton 
                            disabled={currentPageOtherStudents === 1}
                            onClick={() => setCurrentPageOtherStudents(prev => Math.max(1, prev - 1))}
                            size="small"
                            style={{ color: 'white' }}
                        >
                            <ChevronLeft />
                        </IconButton>
                        <span style={{ color: 'white', fontSize: '14px', minWidth: '150px', textAlign: 'center' }}>
                            Page {currentPageOtherStudents} of {Math.ceil(getOtherStudentsVocab.length / itemsPerPage)} ({getOtherStudentsVocab.length} items)
                        </span>
                        <IconButton 
                            disabled={currentPageOtherStudents >= Math.ceil(getOtherStudentsVocab.length / itemsPerPage)}
                            onClick={() => setCurrentPageOtherStudents(prev => Math.min(Math.ceil(getOtherStudentsVocab.length / itemsPerPage), prev + 1))}
                            size="small"
                            style={{ color: 'white' }}
                        >
                            <ChevronRight />
                        </IconButton>
                    </div>
                )}
              </>
            )}
                </div>
                    </ModalContent>
                </ResizeAndDragabble>
        )}
        {assignmentAiModal &&
            <QnALoader
                assignmentAiModal={assignmentAiModal}
                setAssignmentAiModal={setAssignmentAiModal}
                handleGenerateMoreQnA={handleGenerateMoreQnA}
                generateQnALoader={generateQnALoader}
                questionGenerator={questionGenerator}
                page={pageId}
                chapter={bookId}
                qnaWord={qnaWord}
                loading={questionLoader}
                pageNumber={pageNumber}
                selectedTypes={selectedTypes}
                setSelectedTypes={setSelectedTypes}
                generatedCount={generatedCount}
                setQuestionGenerator={setQuestionGenerator}
            />
        }
        </div>
    </SentryWrap>
    );
};

export default Vocabilary;


